export default __webpack_public_path__ + "static/media/riddles.1d76d1e5.mp4";